import {
  Error,
  ADD_ATTENDENCE,
  UPDATE_ATTENDENCE,
  DELETE_ATTENDENCE,
  GET_ATTENDENCE,
} from "../type";
const initialState = {
  AddAttendence: [],
  GetAttendence: [],
  UpdateAttendence: [],
  DeleteAttendence: [],
};
const AttendenceR = (state = initialState, action) => {
  switch (action.type) {
    case GET_ATTENDENCE:
      return {
        ...state,
        GetAttendence: action.payload,
      };
    case ADD_ATTENDENCE:
      return {
        GetAttendence: state.GetAttendence,
        AddAttendence: action.payload,
      };
    case UPDATE_ATTENDENCE:
      return {
        GetAttendence: state.GetAttendence,
        UpdateAttendence: action.payload,
      };
    case DELETE_ATTENDENCE:
      return {
        GetAttendence: state.GetAttendence,
        DeleteAttendence: action.payload,
      };
    case Error:
      return {
        GetAttendence: action.payload,
      };
    default:
      return state;
  }
};
export default AttendenceR;
